import { useState } from "react";

export default function Settings({ t }) {
  const CARD=t.card,BORDER=t.border,TEXT=t.text,SUB=t.sub,PRI=t.pri,GRN=t.grn,RED=t.red;

  const [settings, setSettings] = useState({
    require_email_verification: true,
    auto_moderate_posts: true,
    allow_guest_browsing: false,
    invite_only: false,
    maintenance_mode: false,
    allow_free_messaging: true,
    max_posts_per_day_free: 5,
    trust_score_for_meetups: 30,
  });

  const [flash, setFlash] = useState("");
  const showFlash = (msg) => { setFlash(msg); setTimeout(() => setFlash(""), 3000); };

  const Toggle = ({ on, onChange }) => (
    <div onClick={onChange} style={{ width: 44, height: 24, borderRadius: 12, background: on ? PRI : BORDER, position: "relative", cursor: "pointer", transition: "background 0.2s", flexShrink: 0 }}>
      <div style={{ position: "absolute", top: 3, left: on ? 22 : 3, width: 18, height: 18, borderRadius: 9, background: "#fff", transition: "left 0.2s", boxShadow: "0 1px 4px rgba(0,0,0,0.3)" }} />
    </div>
  );

  return (
    <div>
      {flash && <div style={{ position: "fixed", top: 20, right: 20, background: GRN, color: "#fff", padding: "10px 20px", borderRadius: 10, fontWeight: 700, fontSize: 13, zIndex: 9999 }}>{flash}</div>}

      <div style={{ fontSize: 22, fontWeight: 800, color: TEXT, marginBottom: 4 }}>⚙️ Settings</div>
      <div style={{ fontSize: 12, color: SUB, marginBottom: 24 }}>Community platform settings and configuration</div>

      {/* Toggle settings */}
      <div style={{ background: CARD, border: `1px solid ${BORDER}`, borderRadius: 14, overflow: "hidden", marginBottom: 20 }}>
        <div style={{ padding: "16px 24px", borderBottom: `1px solid ${BORDER}` }}>
          <div style={{ fontSize: 14, fontWeight: 700, color: TEXT }}>Platform Toggles</div>
        </div>
        {[
          { key: "require_email_verification", label: "Require Email Verification", desc: "New users must verify their email before posting" },
          { key: "auto_moderate_posts", label: "Auto-Moderate Posts", desc: "AI content filtering for flagged content" },
          { key: "allow_guest_browsing", label: "Allow Guest Browsing", desc: "Non-members can view public posts without logging in" },
          { key: "invite_only", label: "Invite-Only Registration", desc: "Require an invitation code to join the platform" },
          { key: "maintenance_mode", label: "Maintenance Mode", desc: "Temporarily disable the community (shows maintenance page)", danger: true },
          { key: "allow_free_messaging", label: "Free User Messaging", desc: "Allow free users to send DMs to other free users" },
        ].map((item, i, arr) => (
          <div key={item.key} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "16px 24px", borderBottom: i < arr.length - 1 ? `1px solid ${BORDER}` : "none", background: item.danger && settings[item.key] ? `${RED}05` : "transparent" }}>
            <div>
              <div style={{ fontSize: 13, fontWeight: 600, color: item.danger ? RED : TEXT }}>{item.label}</div>
              <div style={{ fontSize: 11, color: SUB, marginTop: 3 }}>{item.desc}</div>
            </div>
            <Toggle on={settings[item.key]} onChange={() => setSettings(s => ({ ...s, [item.key]: !s[item.key] }))} />
          </div>
        ))}
      </div>

      {/* Numeric settings */}
      <div style={{ background: CARD, border: `1px solid ${BORDER}`, borderRadius: 14, overflow: "hidden", marginBottom: 20 }}>
        <div style={{ padding: "16px 24px", borderBottom: `1px solid ${BORDER}` }}>
          <div style={{ fontSize: 14, fontWeight: 700, color: TEXT }}>Platform Limits</div>
        </div>
        {[
          { key: "max_posts_per_day_free", label: "Max Posts/Day (Free)", desc: "Maximum posts a free user can publish per day", min: 1, max: 20 },
          { key: "trust_score_for_meetups", label: "Min Trust Score for Meetups", desc: "Minimum trust score required to access meetup requests", min: 0, max: 100 },
        ].map((item, i, arr) => (
          <div key={item.key} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "16px 24px", borderBottom: i < arr.length - 1 ? `1px solid ${BORDER}` : "none" }}>
            <div>
              <div style={{ fontSize: 13, fontWeight: 600, color: TEXT }}>{item.label}</div>
              <div style={{ fontSize: 11, color: SUB, marginTop: 3 }}>{item.desc}</div>
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
              <button onClick={() => setSettings(s => ({ ...s, [item.key]: Math.max(item.min, s[item.key] - 1) }))} style={{ width: 32, height: 32, borderRadius: 8, border: `1px solid ${BORDER}`, background: "transparent", color: TEXT, fontSize: 18, cursor: "pointer" }}>−</button>
              <span style={{ fontSize: 18, fontWeight: 800, color: PRI, minWidth: 40, textAlign: "center" }}>{settings[item.key]}</span>
              <button onClick={() => setSettings(s => ({ ...s, [item.key]: Math.min(item.max, s[item.key] + 1) }))} style={{ width: 32, height: 32, borderRadius: 8, border: `1px solid ${BORDER}`, background: "transparent", color: TEXT, fontSize: 18, cursor: "pointer" }}>+</button>
            </div>
          </div>
        ))}
      </div>

      {/* Platform info */}
      <div style={{ background: CARD, border: `1px solid ${BORDER}`, borderRadius: 14, padding: "20px 24px", marginBottom: 20 }}>
        <div style={{ fontSize: 14, fontWeight: 700, color: TEXT, marginBottom: 16 }}>ℹ️ Platform Info</div>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
          {[
            { label: "Platform Name", value: "Geilstore Community" },
            { label: "Domain", value: "community.geilstore.com" },
            { label: "Backend", value: "Laravel 10 + MySQL" },
            { label: "Frontend", value: "React SPA" },
            { label: "Payments", value: "M-Pesa Daraja API" },
            { label: "Auth", value: "Laravel Sanctum JWT" },
            { label: "Storage", value: "DigitalOcean Droplet" },
            { label: "Environment", value: "Production" },
          ].map((item, i) => (
            <div key={i} style={{ display: "flex", justifyContent: "space-between", padding: "8px 0", borderBottom: `1px solid ${BORDER}` }}>
              <span style={{ fontSize: 12, color: SUB }}>{item.label}</span>
              <span style={{ fontSize: 12, fontWeight: 700, color: TEXT }}>{item.value}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Save button */}
      <button onClick={() => showFlash("Settings saved ✓")} style={{ width: "100%", padding: "14px 0", borderRadius: 12, border: "none", background: `linear-gradient(135deg, ${PRI}, #a23ad1)`, color: "#fff", fontSize: 15, fontWeight: 700, cursor: "pointer" }}>
        💾 Save Settings
      </button>
    </div>
  );
}